<app-attachment *ngFor="let attachment of attachments$ | async; let i = index; trackBy: trackByFn"
  [attachment]="attachment"
  (uploaded)="uploaded.emit($event)"
  (removed)="removed.emit($event)"
  (click)="viewAttachments(i)">
</app-attachment>